<span class="vs-select-option-label min-w-0 truncate"><ng-content></ng-content></span>
<vs-icon name="check" size="16" class="hidden text-themed group-aria-selected:block shrink-0"></vs-icon>
